import { App, Avatar, Button, Card, Typography } from 'antd';

import WhatsAppLink from 'v2/components/Shared/WhatsAppLink';
import type { AccountManager } from 'v2/interfaces/user';
import analyticsService from 'v2/services/analytics';

import { Icon } from '@eduzz/ui-antd-theme';

interface IProps {
  data: AccountManager;
}

function ManagerInfo({ data }: IProps) {
  const { message } = App.useApp();
  const photoSrc = data.photo ? data.photo : '/img/avatar-default.svg';

  async function handleCopyEmail(): Promise<void> {
    try {
      await navigator.clipboard.writeText(data.email);
      message.success('E-mail copiado.');
      analyticsService.sendEvent('Email Button Clicked', 'Dashboard - Account Manager');
    } catch (err) {
      message.error('Falha ao copiar E-mail!');
    }
  }

  function handleRedirectWhatsApp() {
    analyticsService.sendEvent('WhatsApp Button Clicked', 'Dashboard - Account Manager');
  }

  return (
    <>
      <Card className='mb-2'>
        <div className='flex flex-col justify-center gap-4'>
          <div className='flex items-center gap-2'>
            <Avatar src={photoSrc} alt='icone gerente de conta' size={40} />
            <div className='flex flex-col'>
              <Typography.Text strong>{data.name}</Typography.Text>
              <Typography.Text type='secondary'>Consultor de sucesso</Typography.Text>
            </div>
          </div>
          <div className='flex gap-4'>
            <Button
              id='btn-copy-email'
              className='m-0 h-8 flex-1'
              onClick={handleCopyEmail}
              icon={<Icon.Mail size={17} />}
            >
              E-mail
            </Button>
            {data.phone ? (
              <WhatsAppLink phone={data.phone} stylesProps='w-1/2'>
                <Button
                  id='btn-redirect-whatsapp'
                  className='m-0 h-8 flex-1'
                  onClick={handleRedirectWhatsApp}
                  block
                  icon={<Icon.MessageCircle size={17} />}
                >
                  WhatsApp
                </Button>
              </WhatsAppLink>
            ) : null}
          </div>
        </div>
      </Card>
    </>
  );
}

export default ManagerInfo;
